import React from "react";
import Helmet from "react-helmet";
import { graphql } from "gatsby";
import Layout from "../components/layout";

const heading = "text-5xl text-center leading-tight text-blue-darkest";

export default function Template({
  data // this prop is injected by GraphQL query
}) {
  const { jupyterNotebook: post } = data;
  const {
    site: {
      siteMetadata: { title: blogTitle }
    }
  } = data;
  console.log(post);
  console.log("?" + post.json.metadata.frontmatter.path);
  return (
    <Layout path={post.json.metadata.frontmatter.path}>
      <div className="blog-post-container p-2">
        <Helmet
          title={`${blogTitle} | ${post.json.metadata.frontmatter.title}`}
        />
        <div className="blog-post">
          {/* <h1 className={heading}>{post.json.metadata.frontmatter.title}</h1>{" "} */}
          <div
            className="blog-post-content px-4 text-grey-darkest"
            dangerouslySetInnerHTML={{ __html: post.html }}
          />
        </div>
      </div>
    </Layout>
  );
}

export const pageQuery = graphql`
  query JupyterPostByPath($path: String!) {
    site {
      siteMetadata {
        title
      }
    }
    jupyterNotebook(
      json: { metadata: { frontmatter: { path: { eq: $path } } } }
    ) {
      html
      json {
        nbformat
        nbformat_minor
        cells {
          cell_type
          execution_count
          source
          outputs {
            output_type
            data {
              image_png
            }
          }
        }
        metadata {
          frontmatter {
            path
            title
            tags
          }
          kernelspec {
            display_name
            language
            name
          }
          language_info {
            file_extension
            mimetype
            name
            nbconvert_exporter
            pygments_lexer
            version
          }
        }
      }
    }
  }
`;
